import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Button, Label, Row, Col } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as yup from 'yup';
import {
  Form,
  Field,
  FormGroup,
  Radio,
  RadioGroup
} from '@availity/form';
import awardeestore from '../stores/awardeestore';
import CustomProgressBar from '../../Common/components/CustomProgressBar';


@observer
export default class AdditionalQuestions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirectTodocuments: false,
      redirectToHousingProfilePage: false
    }

    if (awardeestore.getAwardeeHousingPageStatus('#additionalquestions') !== 'stepwizard-step active') {
      awardeestore.setAwardeeHousingPageStatus('#additionalquestions', 'active');
    }

    if(window.performance) {
			if(performance.navigation.type == 1) {
        awardeestore.resetAwardeeHousingPageStatus();
				window.location.href = '#';
			}
		}
  }

  componentDidMount() {
    window.onpopstate = () => {
      this.props.history.go(1);
    }
  }

  setShortTermRentalRadio = value => {
    awardeestore.setShortTermRentalRadio(value);
    if(value === 'Yes') 
      awardeestore.setAdditionalInfoDetails('shortTermRentalField', '');
  }

  setShortTermRentalDetails = event => {
    const { name, value } = event.target;
    awardeestore.setAdditionalInfoDetails(name, value);
  }

  setMoneyManagerRadio = value => {
    awardeestore.setMoneyManagerRadio(value);
  }

  setOweMoneyRadio = value => {
    awardeestore.setoweMoneyRadio(value);
    if(value === 'Yes')
      awardeestore.setAdditionalInfoDetails('oweMoneyField', '');
  }

  setOweMoneyDetails = event => {
    const { name, value } = event.target;
    awardeestore.setAdditionalInfoDetails(name, value);
  }

  goBack = () => {
    this.setState({ redirectToHousingProfilePage: true });

  }

  submit = () => {
    awardeestore.completedSteps.additionalquestions = true;
    this.setState({  redirectTodocuments: true });
  }

  render() {
    const { redirectToHousingProfilePage,  redirectTodocuments } = this.state;

    const {
      awardeeHousingPages,
      additionalInfo
    } = awardeestore;

		const{location} = this.props;

		const fromReviewAndSubmitPage = location && location.state && location.state.fromReviewAndSubmitPage;

    if (redirectToHousingProfilePage) {
      return <Redirect to='/housingprofile' />
    }

    if ( redirectTodocuments) {
       return <Redirect to={fromReviewAndSubmitPage ?  "/reviewAndSubmit" : '/documents'}/>

    }

    return (
      <div className='border-form'>
        <CustomProgressBar pages={awardeeHousingPages} />

        <div className='spacer-28' />

        <small className='required-fields'>*required</small>
        <div className='spacer-28' />
        <h2 className='poppinsH2'>
          Additional Questions
        </h2>
        <Form
          enableReinitialize
          initialValues={{
            shortTermRentalRadio: additionalInfo.shortTermRentalRadio,
            shortTermRentalField: additionalInfo.shortTermRentalDetails,
            moneyManagerRadio: additionalInfo.moneyManagerRadio,
            oweMoneyRadio: additionalInfo.oweMoneyRadio,
            oweMoneyField: additionalInfo.setOweMoneyDetails
          }}
          onSubmit={this.submit}
          validationSchema={yup.object().shape({
            shortTermRentalRadio: yup
              .string()
              .required("Required"),
            shortTermRentalField:
              additionalInfo.shortTermRentalRadio === 'Yes' && !additionalInfo.shortTermRentalDetails ?
                yup
                  .string()
                  .required('Please specify the details!')
                :
                yup
                  .string(),
            moneyManagerRadio: yup
              .string()
              .required("Required"),
            oweMoneyRadio: yup
              .string()
              .required("Required"),
            oweMoneyField:
              additionalInfo.oweMoneyRadio === 'Yes' && !additionalInfo.oweMoneyDetails ?
                yup
                  .string()
                  .required('Please specify the details!')
                :
                yup
                  .string(),

          })}
        >

          <div className='spacer-28' />
          <Row>
            <Col>
              <FormGroup for="shortTermRentalRadio" className='label-font'>
                <label>
                  <b>Do you need short-term rental assistance to cover move-in costs and/or other costs as you work with your case manager to identify and/or obtain permanent affordable housing?*</b>
                </label>
                <RadioGroup inline value={additionalInfo.shortTermRentalRadio} name="shortTermRentalRadio" onChange={this.setShortTermRentalRadio} >
                  <Radio className="label-font-round" label="Yes" value="Yes" />
                  <Radio className="label-font-round" label="No" value="No" />
                </RadioGroup>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm='8'>
              {
                additionalInfo.shortTermRentalRadio !== 'Yes' ?
                  <div className="disableShortTermDetailsField" hidden>
                    <FormGroup for="shortTermRentalField" className="label-font">
                      <Field
                        type="textarea"
                        name="shortTermRentalField"
                        id="shortTermRentalField"
                        className="straighten-borders"
                        label="What costs need to be covered with other resources"
                        value={additionalInfo.shortTermRentalDetails}
                        onChange={this.setShortTermRentalDetails}
                        disabled
                        maxLength={2000}
                      />
                      <Label style={{ display: 'block' }} className="small text-right">2000 Character max</Label>

                    </FormGroup>
                  </div>
                  :
                  <div>
                    <FormGroup for="shortTermRentalField" className="label-font">
                      <Field
                        type="textarea"
                        name="shortTermRentalField"
                        id="shortTermRentalField"
                        className="straighten-borders"
                        label={<strong>What costs need to be covered with other resources?*</strong>}
                        value={additionalInfo.shortTermRentalDetails}
                        onChange={this.setShortTermRentalDetails}
                        maxLength={2000}
                      />
                      <Label style={{ display: 'block' }} className="small text-right">2000 Character max</Label>

                    </FormGroup>
                  </div>
              }
            </Col>
          </Row>
          <div className='spacer-28' />
          <Row>
            <Col>
              <FormGroup for="moneyManagerRadio" className='label-font'>
                <label>
                  <b>Do you have someone who helps manage your money? (i.e. a payee)?*</b>
                </label>
                <RadioGroup inline value={additionalInfo.moneyManagerRadio} name="moneyManagerRadio" onChange={this.setMoneyManagerRadio} >
                  <Radio className="label-font-round" label="Yes" value="Yes" />
                  <Radio className="label-font-round" label="No" value="No" />
                </RadioGroup>
              </FormGroup>
            </Col>
          </Row>
          <div className='spacer-28' />
          <Row>
            <Col>
              <FormGroup for="oweMoneyRadio" className='label-font'>
                <label>
                  <b>Do you know if you owe money to a former landlord or Public Housing Authority for unpaid rent or damages?*</b>
                </label>
                <RadioGroup inline value={additionalInfo.oweMoneyRadio} name="oweMoneyRadio" onChange={this.setOweMoneyRadio} >
                  <Radio className="label-font-round" label="Yes" value="Yes" />
                  <Radio className="label-font-round" label="No" value="No" />
                </RadioGroup>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm='8'>
              {
                additionalInfo.oweMoneyRadio !== 'Yes' ?
                  <div className="disableOweMoneyDetailsField" hidden>
                    <FormGroup for="oweMoneyField" className="label-font">
                      <Field
                        type="textarea"
                        name="oweMoneyField"
                        id="oweMoneyField"
                        className="straighten-borders"
                        label="Please provide Details"
                        value={additionalInfo.oweMoneyDetails}
                        onChange={this.setOweMoneyDetails}
                        disabled
                        maxLength={2000}
                      />
                      <Label style={{ display: 'block' }} className="small text-right">2000 Character max</Label>

                    </FormGroup>
                  </div>
                  :
                  <div>
                    <FormGroup for="oweMoneyField" className="label-font">
                      <Field
                        type="textarea"
                        name="oweMoneyField"
                        id="oweMoneyField"
                        className="straighten-borders"
                        label={<strong>Please provide details*</strong>}
                        value={additionalInfo.oweMoneyDetails}
                        onChange={this.setOweMoneyDetails}
                        maxLength={2000}
                      />
                      <Label style={{ display: 'block' }} className="small text-right">2000 Character max</Label>

                    </FormGroup>
                  </div>
              }
            </Col>
          </Row>
          <div className='spacer-28' />

          <Button type="button" color={"primary"} className={'btn btn-primary straighten-borders buttonBack'} onClick={this.goBack}>
            Back
          </Button>
          <Button type="submit" color={"primary"} className={'btn btn-primary awardeeNextBtn mb-50'}>
            Next
          </Button>
        </Form>
      </div>
    );
  }
}

AdditionalQuestions.propTypes = {
  history: PropTypes.object,
	location: PropTypes.shape({
		state: PropTypes.shape({
			fromReviewAndSubmitPage: PropTypes.bool
		})
	})
}
